import { H2, H5 } from "../../../../AbstractElements";
import { FormGroup, Input, Label } from "reactstrap";
import { RegisterWizardForm  } from "../../../../Type/Pages";
import { CityWizard, CountryWizard, EnterYourEmailPasswordToLoginWizard, SignUpToAccount, StateWizard } from "../../../../Constant";

const DoneForm = ({ formValue, getUserData }: RegisterWizardForm) => {
  const { country, state, city } = formValue;

  return (
    <div id="step-4" className="content">
      <div className="wizard-title">
        <H2>{SignUpToAccount}</H2>
        <H5 className="text-muted mb-4">{EnterYourEmailPasswordToLoginWizard}</H5>
      </div>
      <div className="login-main">
        <div className="theme-form">
          <FormGroup className="mb-3">
            <Label className="control-label" check>{CountryWizard}</Label>
            <Input value={country} onChange={getUserData} name="country" className="mt-1" type="text" placeholder="Country" required />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label className="control-label" check>{StateWizard}</Label>
            <Input value={state} onChange={getUserData} className="mt-1" name="state" type="text" placeholder="State" required />
          </FormGroup>
          <FormGroup className="form-group mb-3">
            <Label className="control-label" check>{CityWizard}</Label>
            <Input value={city} onChange={getUserData} name="city"  className="mt-1" type="text" placeholder="City" required />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default DoneForm;
